<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            label="평가기간"
            name="assessmentDates"
            v-model="searchParam.assessmentDates"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="RAM_ASSESS_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ramAssessTypeCd"
            label="평가구분-정기/수시/최초"
            v-model="searchParam.ramAssessTypeCd"
          ></c-select>
        </div>
        <div v-if="isRamTechniqueCd" class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="stepItems"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="ramStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.ramStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="위험성평가 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      rowKey="ramRiskAssessmentPlanId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fmPop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          ramTechniqueCd: '',
          regUserId: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        assessmentDates: [],
        ramAssessTypeCd: null,
        stepCd: null,
        ramTechniqueCd: '',
        isVendor: false,
        regUserId: '',
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'assessmentName',
            field: 'assessmentName',
            label: '평가명',
            align: 'left',
            style: 'width:250px',
            sortable: true,
            type: 'link',
          },
          {
            name: 'ramStepName',
            field: 'ramStepName',
            label: 'LBLSTEPPROGRESS',
            align: 'center',
            style: 'width:100px',
            sortable: true
          },
          {
            name: 'assessmentDate',
            field: 'assessmentDate',
            label: '평가기간',
            align: 'center',
            style: 'width:150px',
            sortable: true
          },
          {
            name: 'ramAssessTypeName',
            field: 'ramAssessTypeName',
            label: '평가구분',
            align: 'center',
            style: 'width:100px',
            sortable: true
          },
          {
            name: 'regUserName',
            field: 'regUserName',
            label: 'LBLREGISTER',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'reviewUserName',
            field: 'reviewUserName',
            label: 'LBLREVIEWER',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'approvalUserName',
            field: 'approvalUserName',
            label: 'LBLAPPROVER',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        height: '500px',
        data: [],
      },
      stepItems: [],
      editable: true,
      listUrl: '',
      linkRow: null,
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    isRamTechniqueCd() {
      return Boolean(this.popupParam.ramTechniqueCd)
    },
    paramInfo() {
      return {
        ramRiskAssessmentPlanId: this.linkRow.ramRiskAssessmentPlanId,
        ramStepCd: this.linkRow.ramStepCd,
        vendorFlag: (this.linkRow.vendorFlag > 0),
      }
    },
    popupOptionInfo() {
      return this.$_.find([
        {
          ramTechniqueCd: 'RT00000001',
          title: 'HAZOP 상세',
          param: this.paramInfo,
          target: () => import(`${'@/pages/ram/hazop/hazopDetail.vue'}`),
        },
        {
          ramTechniqueCd: 'RT00000005',
          title: 'K-PSR 상세',
          param: this.paramInfo,
          target: () => import(`${'@/pages/ram/kpsr/kpsrDetail.vue'}`),
        },
        {
          ramTechniqueCd: 'RT00000010',
          title: 'CHECKLIST 상세',
          param: this.paramInfo,
          target: () => import(`${'@/pages/ram/checklist/checkListDetail.vue'}`),
        },
        {
          ramTechniqueCd: 'RT00000015',
          title: 'JSA 상세',
          param: this.paramInfo,
          target: () => import(`${'@/pages/ram/jsa/jsaDetail.vue'}`),
        },
        {
          ramTechniqueCd: 'RT00000020',
          title: 'KRAS 상세',
          param: this.paramInfo,
          target: () => import(`${'@/pages/ram/kras/krasDetail.vue'}`),
        },
        {
          ramTechniqueCd: 'RT00000025',
          title: '4M 상세',
          param: this.paramInfo,
          target: () => import(`${'@/pages/ram/4m/4mDetail.vue'}`),
        },
        {
          ramTechniqueCd: 'RT00000030',
          title: 'CHARM 상세',
          param: this.paramInfo,
          target: () => import(`${'@/pages/ram/charm/charmDetail.vue'}`),
        },
      ], { ramTechniqueCd: this.linkRow.ramTechniqueCd })
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.assessPlan.list.url
      // code setting
      if (this.popupParam.regUserId) {
        this.$set(this.searchParam, 'regUserId', this.popupParam.regUserId)
      }
      if (this.isRamTechniqueCd) {
        this.$set(this.searchParam, 'ramTechniqueCd', this.popupParam.ramTechniqueCd)
        let stepGrpCd = '';
        
        switch (this.popupParam.ramTechniqueCd) {
          case 'RT00000001':
            stepGrpCd = 'RAM_HAZOP_STEP_CD';
            break;
          case 'RT00000005':
            stepGrpCd = 'RAM_KPSR_STEP_CD';
            break;
          case 'RT00000010':
            stepGrpCd = 'RAM_CHECKLIST_STEP_CD';
            break;
          case 'RT00000015':
            stepGrpCd = 'RAM_JSA_STEP_CD';
            break;
          case 'RT00000020':
            stepGrpCd = 'RAM_KRAS_STEP_CD';
            break;
          case 'RT00000025':
            stepGrpCd = 'RAM_4M_STEP_CD';
            break;
          case 'RT00000030':
            stepGrpCd = 'RAM_CHARM_STEP_CD';
            break;
          default:
            break;
        }
        if (stepGrpCd) {
          this.$comm.getStepItems(stepGrpCd).then(_result => {
            _result.splice(1, 1);
            this.stepItems = _result;
          });
        }
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.$set(this.$data, 'linkRow', row)
      this.$_.extend(this.popupOptions, this.popupOptionInfo)
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
  }
};
</script>
